'use strict';

import {ngDepModel} from './ngdepmodel.js';

export class evlCriterionModel extends ngDepModel
{
	hasParent = false;
	type = 'criteria';
	
	constructor(itemData, $filter, jsDataService){
		super(itemData, $filter, jsDataService);
		this.setupItemData(itemData);
	}
	
	getMax(){
		if(isNaN(this.max) || !this.max){
			return 0;
		}
		return parseInt(this.max);
	}
	
	getThreshold(){
		if(isNaN(this.threshold) || !this.threshold){
			return 0;
		}
		return parseInt(this.threshold);
	}
	
	getScore(){
		if(isNaN(this.score) || !this.score){
			return 0;
		}
		return Number(this.score.toFixed(2));
//		return parseInt(this.score);
	}
	
	isTooLow(){
		return (this.getScore() < this.getThreshold());
	}
	
	isTooHigh(){
		return (this.getScore() > this.getMax());
	}
}